import {FC} from "react"

import {ReactionsWithForm} from "@frontend/components"
import {linkStyles} from "@frontend/components/ui"
import {useTranslation} from "@frontend/i18n"
import type {
  RemediationPageDataPeek,
  RemediationPageDataRemediation,
} from "@ri2/app/server/routers/getRemediationPageData"
import {Feedback, Recommendation} from "@ri2/db/client"
import {css, cx} from "@styled-system/css"
import {hstack} from "@styled-system/patterns"

import {Reason} from "./reason"

interface Props {
  recommendation: Recommendation
  feedback?: Feedback
  caseId: string
  type: RemediationPageDataRemediation | RemediationPageDataPeek
  openModal: () => void
}

export const RecommendationBasedOn: FC<Props> = ({
  recommendation,
  feedback,
  caseId,
  type,
  openModal,
}) => {
  const t = useTranslation()
  return (
    <>
      <div
        className={hstack({
          width: "100%",
          justifyContent: "space-between",
        })}
      >
        <div
          className={hstack({
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "flex-start",
            gap: 8,
            desktopDown: {
              flexWrap: "wrap",
            },
          })}
        >
          <span
            className={css({
              textStyle: "captionRegular",
              color: "text.primary",
              desktopDown: {
                width: "100%",
              },
            })}
          >
            {t("cause.nextStep.recommendationBasedOn")}
          </span>
          {recommendation.reasons.map((reason) => (
            <Reason key={reason} reason={reason} />
          ))}
          <button
            onClick={openModal}
            className={cx(
              linkStyles({variant: "standalone"}),
              css({textStyle: "captionMedium"}),
            )}
          >
            {t("cause.nextStep.learnMore")}
          </button>
        </div>
        <div
          className={css({
            display: "none",
            desktop: {
              display: "block",
            },
          })}
        >
          <ReactionsWithForm
            on={
              type.type === "remediation"
                ? {
                    on: "remediation",
                    caseId,
                    causeId: type.cause.id,
                    type: "RECOMMENDATION",
                  }
                : {
                    on: "peek",
                    caseId,
                    type: "RECOMMENDATION",
                  }
            }
            currentFeedback={feedback}
            className={css({marginRight: {base: 16, desktop: 0}})}
          />
        </div>
      </div>
    </>
  )
}
